import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { map, filter, Observable } from 'rxjs';
import { CommonModule } from '@angular/common';
import { Store } from '@ngrx/store';
import { AppLauncherInfo } from '../../../store/appLauncher/appLauncher.model';
import { appLauncherSuccess } from '../../../store/appLauncher/appLauncher.actions';

@Component({
  selector: 'app-token-error-page',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './token-error-page.component.html',
  styleUrl: './token-error-page.component.css'
})
export class TokenErrorPageComponent implements OnInit{
  errorMessage$!: Observable<string>;
  errorMessage2$!: Observable<string>;
  constructor(private route: ActivatedRoute, private store: Store<{appLauncher: AppLauncherInfo}>) {}

  ngOnInit(): void {
    const isPunchOut = true;
    const wasSuccess = false;
    const user =  ''
    const api_key = ''
    const equipment_code = ''
    this.store.dispatch(appLauncherSuccess({
      user,
      equipment_code,
      api_key,
      isPunchOut,
      wasSuccess
    }));  
    this.errorMessage$ = this.route.queryParamMap.pipe(
      map(params => params.get('message') ?? '')
    );

    this.errorMessage2$ = this.route.queryParamMap.pipe(
      map(params => params.get('message2') ?? '')
    );
  }
}